// import store from '@/store';
// import moment from "moment";
import consts from "@/consts";

const defaultSetRoute = {
    recycleBin: (route, router) => {
        if(route.meta?.mainRouteName !== consts.routerNames.recycle_bin.main) {
            if(consts.app.$isDevelopment) console.warn('recycleBin', route);
            return false
        }
        router.push({
            name: consts.routerNames.recycle_bin.main,
            params: {},
            query: {}
        })
    },
    unitsEdit: (route, router, unitId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.recycle_bin.main) {
            if(consts.app.$isDevelopment) console.warn('unitsEdit', route);
            return false
        }
        router.push({
            name: consts.routerNames.recycle_bin.edit.unit,
            params: {
                unitId,
            },
            query: {...route.query}
        })
    },
    unitsHistory: (route, router, unitId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.recycle_bin.main) {
            if(consts.app.$isDevelopment) console.warn('unitsHistory', route);
            return false
        }
        router.push({
            name: consts.routerNames.recycle_bin.history.unit,
            params: {
                unitId,
            },
            query: {...route.query}
        })
    },
    usersHistory : (route, router, userId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.recycle_bin.main) {
            if(consts.app.$isDevelopment) console.warn('usersHistory', route);
            return false
        }
        router.push({
            name: consts.routerNames.recycle_bin.history.user,
            params: {
                userId,
            },
            query: {...route.query}
        })
    },
}

const routes = (process.env.VUE_APP_PACKAGE !== 'prometheus.admin') ? [] : [
    {
        path: 'recycle-bin',
        name: consts.routerNames.recycle_bin.main,
        meta: {
            mainRouteName: consts.routerNames.recycle_bin.main,
            bodyGrid: "1X1",
            setRoute: defaultSetRoute,
        },
        component: () => import('@/views/prometheus/admin/RecycleBinPage.vue'),
        children: [
            {
                path: ':unitId(\\d+)/history',
                name: consts.routerNames.recycle_bin.history.unit,
                meta: {
                    blockingRoutesTransitionFromOutside: true,
                    sectionPopupByRoute: {
                        SectionWrapByRoutePopup: {
                            class: 'popup-full',
                            titlePosition: 'left'
                        }
                    }
                },
                props: {
                    sectionPopupByRoute: (route) => ({
                        objectName: 'unit',
                        objectId: +route.params.unitId,
                    })
                },
                components: {
                    sectionPopupByRoute: () => import('@/components/objects_audit/objects/ObjectsChangesTableTreeList.vue'),
                }
            },
            {
                path: ':userId(\\d+)/history',
                name: consts.routerNames.recycle_bin.history.user,
                meta: {
                    blockingRoutesTransitionFromOutside: true,
                    sectionPopupByRoute: {
                        SectionWrapByRoutePopup: {
                            class: 'popup-full',
                            titlePosition: 'left'
                        }
                    }
                },
                props: {
                    sectionPopupByRoute: (route) => ({
                        objectName: 'user',
                        objectId: route.params.userId,
                    })
                },
                components: {
                    sectionPopupByRoute: () => import('@/components/objects_audit/objects/ObjectsChangesTableTreeList.vue'),
                }
            },
        ]
    },
];

export default routes;